import ChevronDownIcon from '../Icons/ChevronDown'
import IconButton from './IconButton'

interface IButtonDown {
    onClick(event?: any): void
    title?: string
}

const ButtonDown = ({ onClick, title }: IButtonDown) => (
    <IconButton title={title} onClick={onClick}>
        <ChevronDownIcon />
    </IconButton>
)

export default ButtonDown
